const en = {
  "add-user.invite-users": "Invite users",
  "add-users.add-more-users": "Add more users",
  "add-users.send-invite": "Send invite",
  "add-users.toasts.success": "Invites sent!",
  "admin-required.message": "You need to be an administrator to see this.",
  "auth.admin-or-user-required":
    "You have to be {user} or an administrator to view this",
  "auth.goodbye": "Goodbye!",
  "auth.sign-out": "Sign out",
  "billing-methods.ehf": "EHF",
  "billing-methods.labels.ehf": "Elektronisk handlesformat",
  "buy-new-subscription.title":
    "You have to purchase a new subscription to regain access to Arbeidsark.",
  "cancel-subscription-success.contact-form": "the contact form",
  "cancel-subscription-success.description":
    "We want to improve. Is there something about Arbeidsark not working they way you want? Please send us an e-mail at {contactLink} or send us a message from {contactForm}.",
  "cancel-subscription-success.title": "Sad to see you go!",
  "cancel-subscription-success.toast-text": "The subscription was cancelled",
  "cancel-subscription.confirm-cancel": "I am sure I want to cancel",
  "cancel-subscription.keep-subscription": "Keep subscription",
  "cancel-subscription.subtitle": "You have access until {date}",
  "cancel-subscription.title":
    "Are you sure you want to cancel your subscription?",
  "change-password.description":
    "You must change your password before logging in for security reasons.",
  "change-password.title": "Change password",
  "change-payment-method-success.title": "Success!",
  "change-payment-method-success.toast": "The card information was changed",
  "change-payment-method.submit-text": "Save",
  "change-payment-method.title": "Change payment method",
  "change-periodicity.save-success": "The billig periodicity was changed",
  "common.absence": "Absence",
  "common.absences": "Absence",
  "common.activate": "Activate",
  "common.active": "Active",
  "common.activities": "Activities",
  "common.activity": "Activity",
  "common.add": "Add",
  "common.add-file": "Add file",
  "common.add-files": "Add files",
  "common.address": "Address",
  "common.age": "Age",
  "common.all": "All",
  "common.app": "App",
  "common.archive": "Archive",
  "common.author": "Author",
  "common.availability":
    "{abbreviate, select, true {Avail.} other {Availability}}",
  "common.back": "Back",
  "common.business": "Business",
  "common.businessOverview": "Business overview",
  "common.cancel": "Cancel",
  "common.cancel-changes": "Cancel Changes",
  "common.category": "Category",
  "common.change-organization": "Change organization",
  "common.city": "City",
  "common.clear": "Clear value",
  "common.close": "Close",
  "common.closed": "Closed",
  "common.codes": "Codes",
  "common.contact-info": "Contact info",
  "common.contact-person": "Contact person",
  "common.content": "Content",
  "common.country": "Country",
  "common.create": "Create",
  "common.create-entry": "Create new entry",
  "common.create-folder": "Create new folder",
  "common.create-worksheet": "Create worksheet",
  "common.creating": "Creating",
  "common.current-password": "Current password",
  "common.dashboard": "Dashboard",
  "common.date": "Date",
  "common.date-validation-not-in-future":
    "Date must be valid and not in the future",
  "common.day-end": "Day end",
  "common.day-start": "Day start",
  "common.days": "{days, plural, =0 {No days} one {# day} other {# days}}",
  "common.deactivate": "Deactivate",
  "common.delete": "Delete",
  "common.delete-alt": "Delete",
  "common.delete-type": "Delete {type}",
  "common.description": "Description",
  "common.detail": "Detail",
  "common.distance": "Distance",
  "common.document": "Document",
  "common.documentation": "Documentation",
  "common.documentationIssues": "Documentation issues",
  "common.documents": "Documents",
  "common.download": "Download",
  "common.driver": "Driver",
  "common.drivers": "Drivers",
  "common.drivers-handbook": "Drivers handbook",
  "common.driversHandbook": "Drivers handbook",
  "common.driving": "Driving",
  "common.driving-data": "Driving data",
  "common.dropdown": "Dropdown",
  "common.dropdown-on-pages": "User dropdown on page",
  "common.edit": "Edit",
  "common.edit-alt": "Edit",
  "common.edit-type": "Edit {type}",
  "common.ehf": "EHF",
  "common.electronic-invoicing": "Electronic invoicing",
  "common.email": "Email",
  "common.email-taken": "Email is already taken",
  "common.employee": "Employee",
  "common.end": "End",
  "common.english": "English",
  "common.entry": "Entry",
  "common.eurovignette": "Eurovignette",
  "common.eurovignettes": "Eurovignettes",
  "common.expired": "Expired",
  "common.favourite": "Favourite",
  "common.favourites": "Favourites",
  "common.files": "Files",
  "common.filter": "Filter",
  "common.first-grade": "First grade",
  "common.first-name": "First name",
  "common.folder": "Folder",
  "common.forum": "Forum",
  "common.gender": "Gender",
  "common.general": "General",
  "common.handbook": "Handbook",
  "common.home": "Home",
  "common.hourlist": "Hourlist",
  "common.hours": "Hours",
  "common.hours-lowercase": "hours",
  "common.in-app": "In app",
  "common.inactive": "Inactive",
  "common.information": "Information",
  "common.invoicing": "Invoicing",
  "common.issue": "Issue",
  "common.issues": "Issues",
  "common.km": "km",
  "common.language": "Language",
  "common.last-name": "Last name",
  "common.liters-short": "l",
  "common.loading": "Loading",
  "common.loading...": "Loading...",
  "common.log-in": "Log in",
  "common.log-out": "Log out",
  "common.login": "Login",
  "common.mathematics": "Mathematics",
  "common.month": "Month",
  "common.monthly": "Yearly",
  "common.multiple": "Multiple",
  "common.my-worksheets": "My worksheets",
  "common.name": "Name",
  "common.new-password": "New password",
  "common.new-password-again": "New password again",
  "common.new-password-sent": "New password is sent to your email!",
  "common.new-worksheet": "New worksheet",
  "common.try-new-generator": "New generator",
  "common.try-new-generator-beta": "Beta",
  "common.next": "Next",
  "common.no": "No",
  "common.norwegian": "Norwegian",
  "common.notification": "Notification",
  "common.nth-grade":
    "{grade, plural, one {first} two {second} =3 {third} other {#th}} grade",
  "common.office": "Office",
  "common.ok": "OK",
  "common.open": "Open",
  "common.opened": "Open",
  "common.operation": "Operation",
  "common.organization": "Organization",
  "common.organization-name": "Organization name",
  "common.organization-number": "Organization number",
  "common.other": "Other",
  "common.other-work": "Other work",
  "common.overtime": "Overtime",
  "common.paper": "Paper",
  "common.password": "Password",
  "common.pause": "Pause",
  "common.pending": "Awaiting approval",
  "common.perks": "Perks",
  "common.phone": "Phone",
  "common.phone-number": "Phone number",
  "common.phone-prefix": "Country prefix",
  "common.post-code": "Postcode",
  "common.postal-code": "Postal code",
  "common.price-per-month": "{price} kr/mth",
  "common.print": "Print",
  "common.range": "Range",
  "common.reason": "Reason",
  "common.reg-nr": "Reg.nr.",
  "common.register": "Register",
  "common.required": "Required",
  "common.responsible": "Responsible",
  "common.rest": "Rest",
  "common.restore": "Restore",
  "common.role": "Role",
  "common.save": "Save",
  "common.save-changes": "Save Changes",
  "common.saving": "Saving",
  "common.school": "School",
  "common.school-grade": "School grade",
  "common.search": "Search ...",
  "common.second-grade": "2nd grade",
  "common.select-placeholder": "Make a choice",
  "common.settings": "Settings",
  "common.sex": "Sex",
  "common.share": "Share",
  "common.shortcuts": "Shortcuts",
  "common.show-all": "Show all",
  "common.single-user": "Single user",
  "common.sms": "SMS",
  "common.start": "Start",
  "common.status": "Status",
  "common.street": "Street",
  "common.subject": "Subject",
  "common.submit": "Submit",
  "common.subscription": "Subscription",
  "common.subscriptions": "Subscriptions",
  "common.sum": "Sum",
  "common.terminal": "Terminal",
  "common.the-email": "The email",
  "common.theme": "Theme",
  "common.thread": "Thread",
  "common.time-entries": "Time entries",
  "common.timesinceposted": "Posted ",
  "common.title": "Title",
  "common.unfavourite": "Unfavourite",
  "common.update": "Update",
  "common.update-entry": "Update entry",
  "common.update-folder": "Update folder",
  "common.updating": "Updating",
  "common.uploaded-attachments": "Uploaded attachments",
  "common.user": "User",
  "common.user-types": "User types",
  "common.userType": "User type",
  "common.username": "Username",
  "common.users": "Users",
  "common.vehicle": "Vehicle",
  "common.week": "Week",
  "common.weeks": "{weeks, plural, =0 {No weeks} one {# week} other {# weeks}}",
  "common.welcome": "Welcome",
  "common.work": "Work",
  "common.year": "Year",
  "common.yearly": "Yearly",
  "common.yes": "Yes",
  "common.zip-code": "Zip",
  "components.language-select.option-label":
    "{lang, select, nb {Norwegian (bokmål)} nn {Norwegian (nynorsk)} en {English (GB)} other {Unknown}}",
  "confirm-reset-password.back-to-login": "Back to login",
  "confirm-reset-password.title": "Enter new password",
  "copy.success": "Copied to clipboard",
  "createUser.title": "Create new user",
  "dashboard.add-user": "Add users",
  "dashboard.lastForumPosts": "Last forum posts",
  "dashboard.register-hours": "Register hours",
  "dashboard.subscription-expiring-banner.title":
    "The trial period ends at {date}. Click here to add a payment method to continue using Arbeidsark.",
  "dashboard.welcome-text-my-worksheets":
    "Here you'll get an overview over your worksheets. You've yet to create any.",
  "dashboard.welcome-text-one":
    "Useful information will be shown here after you have created a worksheet.",
  "dashboard.welcome-text-two":
    "Create a new worksheet by clicking the button below.",
  "document.files-for-document": "Files attached to {name}",
  "documentation.documentation-for-control": "Documentation for control",
  "documentation.drive-and-rest-time": "Driving and resting time",
  "documents.documents-to-user": "Documents to {user}",
  "documents.expiration-date": "Expiration date",
  "documents.name-on-document": "Name on document",
  "documents.notification-time": "Time for notification",
  "documents.number-id": "Number/ID",
  "documents.responsible-user": "Responsible user",
  "documents.show-files": "Show files",
  "documents.upload-document": "Upload document",
  "documents.view-file": "View file",
  "error.address-required": "Address is required",
  "error.categories": "Could not get categories",
  "error.city-required": "City is required",
  "error.contact-person-phone-required":
    "Contact person phone number is required",
  "error.contact-person-required": "Contact person name is required",
  "error.could-not-change-profile-information":
    "Could not change profile information",
  "error.could-not-check-in": "Could not check in",
  "error.could-not-check-out": "Could not check out",
  "error.could-not-create-type": "Could not create {type}",
  "error.could-not-edit-type": "Could not edit {type}",
  "error.could-not-find-data": "Could not find table data",
  "error.could-not-read-file": "Could not read file",
  "error.create-issue": "Could not create issue",
  "error.field-is-required": "{field} is required",
  "error.files.could-not-read": "Could not read file",
  "error.first-name-required": "First name is required",
  "error.generic": "An error has occured",
  "error.generic-server-error":
    "Something went wrong at the server. Please try again.",
  "error.internal-number-required": "Internal number is required",
  "error.invalid-file-type": "Invalid file type",
  "error.invalid-value": "Invalid value",
  "error.last-name-required": "Last name is required",
  "error.name-exists": "An entry with this name already exists",
  "error.need-organization-name": "Organization name must be present",
  "error.no-empty-fields": "All fields are empty",
  "error.no-first-name": "Missing first name",
  "error.no-valid-fields": "No valid fields",
  "error.phone-number-required": "Phone number is required",
  "error.postal-code-required": "Postal code is required",
  "error.type-already-exist": "{type} already exist",
  "error.update-issue": "Could not update issue",
  "error.users-already-exist": "Users that already exists: ",
  "error.valid-email-required": "Valid email is required",
  "error.wrong-username-or-password": "Wrong username or password",
  "errors.change-password-weak": "The password is too weak",
  "errors.common.name-already-exists": "Name already exists",
  "errors.defaults.does-not-exist": "The object does not exist",
  "errors.defaults.foreign-key-constraint":
    "The object is referencing something that doesn't exist",
  "errors.defaults.invalid-value": "An invalid value was provided",
  "errors.defaults.not-permitted": "Your user is not permitted to do this",
  "errors.defaults.unique-constraint": "The object must be unique",
  "errors.from-code.bad-input": "The input was invalid",
  "errors.from-code.configuration-not-found":
    "A valid configuration for the input was not found. Try adjusting the grade and/or operation inputs.",
  "errors.from-code.crossword-computation-failed":
    "The crossword computation failed. It might mean that a crossword for the input wordlist is very hard to generate. Try again or adjust your wordlist.",
  "errors.from-code.crossword-computation-timed-out":
    "The crossword computation timed out. It might mean that a crossword for the input wordlist is very hard to generate. Try again or adjust your wordlist.",
  "errors.from-code.crossword-word-too-large":
    "You have entered a word which is too long for fitting into a crossword.",
  "errors.from-code.division-calculation-timed-out":
    "Generating a valid division task failed. Probably this is just bad luck. Please try again. If the error persists, contact us using the feedback button.",
  "errors.from-code.division-cannot-fit-half-page-grid-size":
    "Fitting a division task with the current numbers into a half page size is not possible. Please lower the input numbers or use the full page layout.",
  "errors.from-code.division-layout-undeterminable":
    "The layout of the division task could not be determined. This is probably our mistake. Sorry. Please contact us using the feedback button.",
  "errors.from-code.email-already-taken": "The email is already taken",
  "errors.from-code.incorrect-password": "Incorrect password",
  "errors.from-code.internal-error": "An internal error has occured",
  "errors.from-code.invalid-credentials": "Bad username or password",
  "errors.from-code.language-category-not-defined":
    "The language category is not defined. Have you unselected it?",
  "errors.from-code.language-not-supported": "The language is not supported",
  "errors.from-code.mathematics-not-allowed-for-wordlist-deduction":
    "Mathematics is not allowed as a subject for wordlist tasks. Try to tweak your configuration or contact us using the feedback button",
  "errors.from-code.no-allowed-modules":
    "No allowed modules were found. You probably have to tweak your configuration.",
  "errors.from-code.not-found": "The object does not exist",
  "errors.from-code.organization-name-already-taken":
    "Organization name already taken",
  "errors.from-code.readingtext-only-full-layout":
    "The module reading texts is only supported with the full page layout.",
  "errors.from-code.readingtexts-no-content-available":
    "An internal error occurred where the selected reading text has no valid content. Please contact us using the feedback button.",
  "errors.from-code.readingtexts-no-data-available":
    "No reading texts are available for the selected grade, language and category.",
  "errors.from-code.remote-stripe-error":
    "Something went wrong at Stripe. Contact us if the problem persists.",
  "errors.from-code.stripe-customer-not-found":
    "Your user is badly configured for Stripe. Please contact us.",
  "errors.from-code.unauthenticated": "You are not logged in",
  "errors.from-code.unauthorized": "You are not authorized to do this",
  "errors.from-code.unknown": "An unknown error has occured",
  "errors.from-code.wordlist-too-small":
    "The wordlist is too small for the task being generated",
  "errors.from-code.wordsearch-computation-failed":
    "The wordsearch computation failed. It might mean that a wordsearch for the input wordlist is very hard to generate. Try again or adjust your wordlist.",
  "errors.from-code.wordsearch-computation-timed-out":
    "The wordsearch computation timed out. It might mean that a wordsearch for the input wordlist is very hard to generate. Try again or adjust your wordlist.",
  "errors.from-code.wordsearch-word-too-large":
    "You have entered a word which is too long for fitting into a wordsearch.",
  "errors.generic-error": "An error has occurred",
  "errors.generic-not-empty-field": "Can't be empty",
  "errors.invalid": "Invalid",
  "errors.invalid-email-address": "Email is invalid",
  "errors.invalid-email-fields": "Invalid input fields: ",
  "errors.invalid-phone-number": "Invalid phone number",
  "errors.max-value-reached": "MAx value reached",
  "errors.min-value-reached": "Minimum value reached",
  "errors.must-be-number": "Must be a number",
  "errors.passwords-do-not-match": "Passwords do not match",
  "errors.passwords-not-equal": "The passwords aren't equal",
  "errors.reload-page": "Reload page",
  "errors.users.could-not-change-password": "Could not change password",
  "errors.worksheets.readingtexts-need-full-layout":
    "Reading texts need full layout",
  "existing-school-waiting-acceptance.description":
    "Your request to join has to be approved by your school before you can use Arbeidsark. Reach out to your local Arbeidskark-administrator if you need help.",
  "existing-school-waiting-acceptance.title": "Awaiting approval by the school",
  "existing-school-waiting-acceptance.toast": "Your user has been created",
  "feide-missing-email.submit": "Update email",
  "feide-missing-email.subtitle":
    "It seems like we didn't get your email from Feide. Please enter it here. You will then shortly get an email from us asking you to verify the email address.",
  "feide-missing-email.title": "We don't know your email",
  "files.drop-to-upload": "Drop files here to upload",
  "files.file-too-large":
    "File {name} is larger than the maxium size of {max}MB.",
  "files.upload-files-here": "Upload files",
  "forgotten-password.forgotten": "Forgotten password?",
  "forgotten-password.go-back": "Go back to login",
  "forgotten-password.success":
    "If your account exists, an e-mail is on it's way with password reset instructions.",
  "forgotten-password.success-message": "An email has been sendt to {user}",
  "forgotten-password.title": "Reset password",
  "forgotten-password.title-success": "Password has been reset",
  "handbook.add_sub_folder": "Add sub folder",
  "handbook.create-entry-success": "Created entry",
  "handbook.create-folder-success": "Created folder",
  "handbook.create_entry": "Create new entry",
  "handbook.edit_folder": "Edit folder",
  "handbook.entry-load-error": "Error loading entry",
  "handbook.entry.delete-success": "Deleted entry",
  "handbook.folder-load-error": "Error loading folder",
  "handbook.folder.delete-success": "Deleted folder",
  "handbook.search": "Search the handbook",
  "handbook.start": "Start",
  "handbook.update-entry-success": "Updated the entry",
  "handbook.update-folder-success": "Updated the folder",
  "institution.add-more-users": "Add more users",
  "institution.back-to-users": "Back to users",
  "institution.invitation-sent": "Invitation has been sent",
  "institution.invitations-sent": "The invitations have been sent",
  "institution.invite-users": "Invite users",
  "institution.send-invitation": "Send invitation",
  "institution.update-success": "Institution information updated successfully!",
  "institutions.sent-invitations": "Sent invitations:",
  "login.already-registered": "Already registered",
  "login.create-user": "Create user",
  "login.create-user-error": "Could not create user",
  "login.email-address-already-in-use": "Email is already in use",
  "login.forgotten-password": "Forgotten password",
  "login.not-already-registered": "Not created a user yet?",
  "login.organization-number-already-in-use":
    "Organization number is already registered",
  "login.password": "Password",
  "login.repeat-password": "Repeat password",
  "modal.and-all-its-content": " and all its content",
  "modal.delete-attachment":
    'Do you want to delete "{title}" from the attachments?',
  "modal.delete-attachment-title": "Delete attachment",
  "modal.delete-folder": "Delete folder",
  "modal.delete-folder-description":
    'Do you want to delete the folder "{title}" and its content?',
  "modal.delete-folder-entry-description":
    'Do you want to delete the entry "{title}"?',
  "modal.delete-folder-entry-title": "Delete entry",
  "modal.delete-folder-title": "Delete folder",
  "modal.delete-type": "Are you sure you want to delete {type}",
  "modal.delete-type-description": "Are you sure you want to delete {type}?",
  "modal.delete-type-title": "Delete {type}",
  "modal.remove-attachment":
    'Do you want to remove "{title}" from the attachment list?',
  "modal.remove-attachment-title": "Remove attachment",
  "new-school-awaiting-confirmation.description":
    "The scool you have registered has to be approved by an administrator before you can use Arbeidsark. You will get an email when the school is approved.",
  "new-school-awaiting-confirmation.title":
    "Awaiting confirmation from Arbeidsark",
  "new-school-awaiting-confirmation.toast": "Your school has been created",
  "new-subscription-required.description":
    "You must buy a new subscription to regain access to Arbeidsark",
  "new-subscription-required.title": "Buy new subscription",
  "notifications.go-to-document": "Go to document",
  "notifications.go-to-thread": "Go to thread",
  "operations.addition": "Addition",
  "operations.division": "Division",
  "operations.multiplication": "Multiplication",
  "operations.subtraction": "Subtraction",
  "pay-for-subscription.purchase": "Purchase subscription",
  "pay-for-subscription.title": "Set payment method",
  "payment-success.description":
    "Your subscription will start after the end of the trial period.",
  "payment-success.title": "Success!",
  "payment-success.toast": "The payment was successful",
  "permissions.add": "Create",
  "permissions.change": "Change",
  "permissions.change_sticky": "Change sticky",
  "permissions.forum-send-email": "Send email",
  "permissions.forum-send-sms": "Send SMS",
  "permissions.no-access-to-page":
    "Your user does not have access to this page",
  "permissions.organization-settings-general": "General",
  "permissions.remove": "Delete",
  "permissions.view": "View",
  "permissions.view-and-change": "View/Change",
  "register-organization.billing-email": "E-mail for invoicing",
  "register-organization.title": "Invoice details",
  "register-school.choose-method.existing-school": "Join existing school",
  "register-school.choose-method.new-school": "Create school",
  "register-school.choose-method.title": "Create new or join existing school.",
  "register-school.chosen-school": "Chosen school",
  "register-school.create-user-and-join-school": "Create user and send request",
  "register-school.create-user-and-school": "Create user and school",
  "register-school.search-for-school": "Search for school",
  "register-school.title": "School — Register personal info",
  "register-user.description":
    "Since this is your first time logging in, you will have to fill in some standard information.",
  "register-user.title": "Fill in your personal info",
  "register.already-registered": "Already registered?",
  "register.bad-token-title": "Invalid url token",
  "register.complete-registration": "Complete registration",
  "register.errors.bad-token": "Bad token",
  "register.errors.expired-token": "Token has expired",
  "register.expired-token-title": "Expired url Token",
  "register.registration-complete": "Registration completed",
  "register.to-login": "Back to login",
  "register.verified-message":
    "The user has been registered and verified. You can now log in to Arbeidsark.",
  "register.verified-title": "User has been registered",
  "register.verify-email-message":
    "An email is being sent with information regarding completing the registration process. Please check your inbox.",
  "register.verify-email-title": "Verify user registration",
  "reset-password.errors.bad-token": "Bad token",
  "reset-password.errors.expired-token": "The reset token has expired.",
  "reset-password.go-back": "Back to login",
  "reset-password.message":
    "Please select a new password. The password must be at least 8 characters long, and cannot solely be made up of numbers.",
  "reset-password.submit": "Change password and log in",
  "reset-password.success": "The password has been reset",
  "reset-password.title": "Reset your password",
  "school-grades.fifth": "5th grade",
  "school-grades.first": "1st grade",
  "school-grades.fourth": "4th grade",
  "school-grades.second": "2nd grade",
  "school-grades.seventh": "7th grade",
  "school-grades.sixth": "6th grade",
  "school-grades.third": "3rd grade",
  "select-multiple.deselect-all": "Remove all",
  "select-multiple.multiple-selected": "Multiple selected",
  "select-multiple.select-all": "Select all",
  "select-sex.label.female": "Female",
  "select-sex.label.male": "Male",
  "select-sex.label.rather-not-say": "Would rather not say",
  "select-subscription.title": "How often do you want to pay?",
  "select-user-setting.description":
    "This screeen lets you choose which user types to be selectable choices in the user dropdowns on certain pages. All users with a user type which is selected below will appear in those dropdowns.",
  "select-user-settings.title": "User dropdown settings",
  "selectOrganization.select": "Select organization",
  "settings.add-absence-type": "Add absence type",
  "settings.add-issue-category": "Add issue category",
  "settings.add-new-terminal": "Add new terminal",
  "settings.added-issue-category": "Added new issue category",
  "settings.admin-paper-option": "Shipped to registered address",
  "settings.billing.billing-email": "Billing email for invoices",
  "settings.billing.title": "Billing",
  "settings.change-logo": "Change logo",
  "settings.class": "Class",
  "settings.current-password": "Current password",
  "settings.edit-type-settings": "Edit {type} settings",
  "settings.errors.change-language": "Could not change preferred language",
  "settings.information": "Information",
  "settings.labels.billing-method": "Billing method",
  "settings.my-settings": "My Settings",
  "settings.new-password": "New password",
  "settings.organization-logo": "Organization logo",
  "settings.organization-settings": "Organization settings",
  "settings.personal-information": "Personal information",
  "settings.repeat-new-password": "Repeat new password",
  "settings.save-changes": "Save changes",
  "settings.save-settings": "Save settings",
  "settings.saved-successfully": "Settings saved",
  "settings.tabs.billing": "Billing",
  "settings.tabs.change-password": "Change password",
  "settings.tabs.information": "Information",
  "settings.toasts.change-language-success": "Changed preferred language",
  "settings.toasts.password-changed-successfully": "Password saved",
  "settings.tv-view": "Show on TV",
  "settings.updated-type": "Updated {type}",
  "settings.updated-userinfo": "Updated user information!",
  "settings.upload": "Upload",
  "settings.upload-type": "Upload {type}",
  "settings.which-class-are-you-teaching": "What class do you normally teach?",
  "settings.work-place": "Work place",
  "setup-success.description": "Your subscription will start immediately.",
  "setup-success.success": "The card info was added",
  "setup-success.title": "Success!",
  "share-link-modal.ingress":
    "Copy the link below and share it with friends or colleagues. The link will give access to this specific worksheet.",
  "share-link-modal.title": "Sharing the worksheet",
  "single-user-email-confirmation.button-with-count":
    "Send new e-mail ({count}s left)",
  "single-user-email-confirmation.button-without-count": "Send new e-mail",
  "single-user-email-confirmation.description":
    "Please check your inbox for an e-mail from us. You must confirm your e-mail before you can use Arbeidsark.",
  "single-user-email-confirmation.new-email-sent": "New email sent",
  "single-user-email-confirmation.title": "Awaiting confirmation of your email",
  "single-user-email-confirmation.toast": "Your user has been created",
  "subscription-cancelled.buy-new": "Buy new subscription",
  "subscription-cancelled.title": "Subscription cancelled",
  "subscription-cancelled.you-have-access-to": "You have access until {date}",
  "subscription-personal.cancel": "Cancel subscription",
  "subscription-personal.has-payment-method-text":
    "You have added a payment method and {sum} kr will be charged at the end of the trial period.",
  "subscription-personal.price": "{price} kr/mth",
  "subscription-personal.reactivate":
    "Changed your mind? Re-activate your subscription.",
  "subscription-personal.reactivate-confirm":
    "Are you sure you want to re-active your subscription?",
  "subscription-personal.regular-button": "Change payment method",
  "subscription-personal.regular-subtitle": "Next payment at {date}",
  "subscription-personal.regular-title": "Standard user",
  "subscription-personal.trial-button": "Finalize purchase",
  "subscription-personal.trial-info":
    "You will receive information about payment and your subscription when your trial period expires.",
  "subscription-personal.trial-subtitle": "Trial expires at {date}",
  "subscription-personal.trial-title": "Free trial",
  "subscription-personal.will-cancel":
    "You have cancelled the subscription and will not be charged by the period end.",
  "subscription-personal.will-cancel-subtitle": "You have access until {date}",
  "subscription-school-cancelled.reactivate-subscription":
    "Reactivate subscription",
  "subscription-school-cancelled.subtitle":
    "You have cancelled the subscription for your school. The access to Arbeidsark will be revoked for all your teachers at {date}.",
  "subscription-school-cancelled.toast.success":
    "Subscription reactivated! Welcome back.",
  "subscription-school-member.description":
    "You have a user that is part of a school subscription. Contact an administrator at your school if you have any questions:",
  "subscription-school.active.edit-billing-info": "Edit billing info",
  "subscription-school.active.will-be-billed-at": "Will be billed at {date}",
  "subscription-school.cancel.confirm-cancel": "I am sure I want to cancel",
  "subscription-school.cancel.keep-subscription": "Keep subscription",
  "subscription-school.cancel.last-access-info":
    "Last day with access will be {date}",
  "subscription-school.cancel.title":
    "Are you sure you want to cancel your subscription?",
  "subscription-school.cancel.toast-text":
    "All users associated with your school will lose access after the subscription ends.",
  "subscription-school.no-subscription.buttonText": "Start new subscription",
  "subscription-school.no-subscription.disclaimer":
    "* By pressing you are accepting on behalf of {school} to be charged a yearly subscription by Arbeidsark AS.",
  "subscription-school.no-subscription.title":
    "Your school has no subscriptio 😔",
  "subscription-school.no-subscription.toast.success": "Welcome back!",
  "subscription-school.trial.activate": "Activate subscription",
  "subscription-school.trial.active-description":
    "You have chosen to activate the subscription after the trial. The first invoice will be sent {date}.",
  "subscription-school.trial.deactivate": "Deactivate subscription",
  "subscription-school.trial.subtitle": "The trial ends at {date}",
  "subscription-school.trial.title": "Free trial - School",
  "subscription-will-cancel.modal.title": "Awesome!",
  "subscriptions.cancel-subscription": "Cancel subscription",
  "subscriptions.change-periodicity": "Change billing periodicity",
  "subscriptions.current-subscription": "Current",
  "subscriptions.try-for-free-30-days": "Try for free for 30 days",
  "table.week-sum": "Weekly sum",
  "terminal.check-in": "Check in",
  "terminal.check-out": "Check out",
  "terminal.checked-in": "Checked in",
  "terminal.checked-in-at": "Checked in at {time}",
  "terminal.checked-in-message":
    "You checked in at {checkIn} and have worked {total} hours",
  "terminal.checked-out": "Checked out",
  "terminal.checked-out-at": "Checked out at {time}",
  "terminal.ip-address": "IP address",
  "terminal.ip-filter-range": "IP filter range",
  "terminal.no-activity-period":
    "You have no registered activity for this period",
  "terminal.no-activity-today": "You have not registered any activity today.",
  "terminal.not-on-network":
    "You need to be on a terminal network to check in or out",
  "terminal.terminal-areas": "Terminal areas",
  "terminal.terminal-name": "Terminal name",
  "terminal.time": "Time",
  "terminal.user-activity": "Activity for {user}",
  "terminal.user-no-activity-period":
    "{user} has no registered activity for chosen period",
  "terminal.your-activity": "Your activity",
  "terminal.your-activity-today": "Your activity today",
  "thread.success-creation": "Created new thread",
  "timesheets.absence-create-type": "Create new absence type",
  "timesheets.absence-type": "Absence type",
  "timesheets.absence-type-name": "Absence type name",
  "timesheets.absence-types": "Absence types",
  "timesheets.absence-types-error-1":
    "Absences cannot be added more than once per day per employee",
  "timesheets.error-registration-absence": "Error registering new absence",
  "timesheets.error-registration-timeentry": "Error registering new time entry",
  "timesheets.error-update-absence": "Error updating absence",
  "timesheets.error-update-timeentry": "Error updating time entry",
  "timesheets.note": "Note",
  "timesheets.register-absence": "Register absence",
  "timesheets.register-timeentry": "Register time entry ",
  "timesheets.success-registration-absence": "New absence registered",
  "timesheets.success-registration-timeentry": "New time entry registered",
  "timesheets.success-update-absence": "Absence updated",
  "timesheets.success-update-timeentry": "Time entry updated",
  "timesheets.update-absence": "Update absence",
  "timesheets.update-timeentry": "Update time entry",
  "timesheets.view-all-absence": "All absence",
  "timesheets.view-all-timeentries": "All time entries",
  "timesheets.view-your-absence": "Your absence",
  "timesheets.view-your-timeentries": "Your time entries",
  "toasts.error": "Error",
  "toasts.error-add-type": "Could not add {type}",
  "toasts.error-delete-type": "Could not delete {type}",
  "toasts.error-update-type": "Could not update {type}",
  "toasts.error.upload-type": "Could not upload {type}",
  "toasts.info": "Information",
  "toasts.success": "Success",
  "toasts.success-add-type": "Successfully added {type}.",
  "toasts.success-delete-type": "Deleted {type}",
  "toasts.success-update-type": "Updated {type}",
  "toasts.success.upload-type": "Uploaded {type}",
  "toasts.warning": "Warning",
  "user-type-settings.delete-prompt-text":
    "Are you sure you want to delete the user type?",
  "user-type-settings.delete-prompt-title": "Delete user type",
  "user-type-settings.description":
    "On this page you can change user types and permissions.",
  "user-type-settings.description-2":
    'Note that all changes under "Change" and "Delete" grants access to change and delete resources created by others. Everyone who has permission to create a resource is also granted access to change their own resources.',
  "user-type-settings.title": "User types and permissions",
  "user-type-settings.toasts.error": "Error updating",
  "user-type-settings.toasts.success": "Updated user types",
  "user-types.change-settings-label": "Change",
  "user-types.create-settings-label": "Create",
  "user-types.driver-activities-self": "Activities (own)",
  "user-types.everyones-driver-activities": "Activities (everybody)",
  "user-types.remove-settings-label": "Delete",
  "user-types.view-settings-label": "View",
  "users.accept-user-join-request": "Accept and activate",
  "users.activated-user": "{email}'s account has been activated.",
  "users.active": "Active",
  "users.add-user": "Add user",
  "users.admin-password-reset-success":
    "The password was reset, and an e-mail has been sent to the user.",
  "users.bio": "Profile Bio",
  "users.birth-number": "Birth Number",
  "users.change-picture": "Change Picture",
  "users.change-profile-picture": "Change image",
  "users.class": "Class",
  "users.contact-person-name": "Contact person name",
  "users.contact-person-phone": "Contact person phone",
  "users.deactivated-user": "{email}'s account has been deactivated.",
  "users.driver-card-number": "Driver card number",
  "users.edit-profile": "Edit profile",
  "users.edit-profile-information": "Edit profile information",
  "users.edit-user": "Edit user",
  "users.grade": "Grade",
  "users.has-no-organizations":
    "You are not affiliated with any organization. Please contact your administrator.",
  "users.inactive": "Inactive",
  "users.internal-number": "Internal number",
  "users.my-profile": "My Profile",
  "users.new": "New user",
  "users.personal-info": "Personal information",
  "users.profile": "Profile",
  "users.reject-user-join-request": "Reject request",
  "users.remove-user-from-organization": "Remove from organization",
  "users.reset-password": "Reset password",
  "users.reset-password-email-sent-by-admin":
    "Reset password email sent to {email}",
  "users.search": "Search for user",
  "users.settings": "My Settings",
  "users.user-activated": "User activated",
  "users.user-deactivated": "User deactivated",
  "users.user-removed-success": "The user was removed.",
  "validation.no-white-space-end": "Whitespace at the end of the name",
  "warnings.worksheets.arithmetic-operation-might-not-be-supported-for-grade":
    "Unusual combination of grade and operation",
  "warnings.worksheets.task-type-not-supported-for-grade":
    "{taskType} is not supported for the chosen grade.",
  "worksheets.arithmetic-detail-modal.set-lowest-highest":
    "Set lowest and highest number",
  "worksheets.buttons.generate-worksheet": "Generate worksheet",
  "worksheets.buttons.regenerate": "Regenerate",
  "worksheets.buttons.hide-options": "Hide customizations",
  "worksheets.buttons.show-options": "Customize",
  "worksheets.delete-success": "Worksheet deleted",
  "worksheets.grade-groups.fiveToSeven": "5th-7th grade",
  "worksheets.grade-groups.oneToFour": "1st-4th grade",
  "worksheets.labels.arithmetic-operation": "Choose arithmetic operation",
  "worksheets.labels.configure": "Configure",
  "worksheets.labels.grade": "Choose grade",
  "worksheets.labels.language-theme": "Select theme",
  "worksheets.labels.math-module": "Choose task types",
  "worksheets.labels.name": "Name",
  "worksheets.labels.number-of-pages": "Number of pages",
  "worksheets.labels.page": "Page",
  "worksheets.labels.page-layout": "Task layout",
  "worksheets.labels.random": "Random",
  "worksheets.labels.random-plural": "Random",
  "worksheets.labels.select-task-types": "Select task types",
  "worksheets.labels.select-theme": "Select graphics",
  "worksheets.labels.task": "Task",
  "worksheets.labels.theme": "Choose graphic",
  "worksheets.language-theme.birds": "Birds",
  "worksheets.language-theme.bugs": "Bugs",
  "worksheets.language-theme.christmas": "Christmas",
  "worksheets.language-theme.clothes": "Clothes",
  "worksheets.language-theme.colours": "Colours",
  "worksheets.language-theme.farm-animals": "Farm animals",
  "worksheets.language-theme.forest-animals": "Forest animals",
  "worksheets.language-theme.fruits-and-berries": "Fruits and berries",
  "worksheets.language-theme.months": "Months",
  "worksheets.language-theme.my-family": "My family",
  "worksheets.language-theme.my-house": "My house",
  "worksheets.language-theme.space": "Space",
  "worksheets.language-theme.the-body-external": "The body (external)",
  "worksheets.language-theme.the-body-internal": "The body (internal)",
  "worksheets.language-theme.vegetables": "Vegetables",
  "worksheets.language-theme.water-seashore": "Along the shore",
  "worksheets.language-theme.weather-and-seasons": "Weather and seasons",
  "worksheets.language-theme.weekdays": "Weekdays",
  "worksheets.options.arithmetic-operation":
    "{operation, select, addition {Addition} subtraction {Subtraktion} multiplication {Multiplication} division {Division} other {Other}}",
  "worksheets.options.math-module":
    "{module, select, arithmeticAlgorithms {Arithmetic algorithms} arithmeticSimple {Arithmetic - Simple} arithmeticFractionsSimple {Arithmetic Fractions - Simple} clockAnalogoue {Clock - Analogue} clockDigital {Clock - Digital} guessTheHouse {Guess the House} numberGrid {Number Grid} numberLines {Number Lines} numberPyramids {Number Pyramids} numberSequence {Number Sequence} numberSort {Number Sort} patterns {Patterns} standardAlgorithm {Standard Algorithm} sudoku {Sudoku} random {Random} other {Random}}",
  "worksheets.options.page-layout":
    "{pageLayout, select, ONE {One per page} ONEONE {One at top, one below} ONETWO {One at top, two below} TWOONE {Two at top, one below} TWOTWO {Two at top, two below} ONEONEONEONE {Four rows with one each} other {Other}}",
  "worksheets.options.theme":
    "{theme, select, christmas {Christmas} easter {Easter} halloween {Halloween} mermaids {Mermaids} numberchars {Numbers & Letters} space {Space} tools {Tools} unicorn {Unicorns} other {Other}}",
  "worksheets.page-layouts.full": "One task per page",
  "worksheets.page-layouts.half": "Two tasks per page",
  "worksheets.search-placeholder": "Search for worksheet...",
  "worksheets.task-types.generic.crossword": "Crossword",
  "worksheets.task-types.generic.readingTexts": "Reading texts",
  "worksheets.task-types.generic.wordSearch": "Word search",
  "worksheets.task-types.mathematics.arithemtic": "Arithmetics",
  "worksheets.task-types.mathematics.arithmetic": "Arithmetic",
  "worksheets.task-types.mathematics.grid": "Number grid",
  "worksheets.task-types.mathematics.guessTheHouse": "Guess the house",
  "worksheets.task-types.mathematics.mathCrossBox": "Cross box",
  "worksheets.task-types.mathematics.neighbourNumbers": "Neighbour numbers",
  "worksheets.task-types.mathematics.numberPatterns": "Number patterns",
  "worksheets.task-types.mathematics.numberSeries": "Number sequences",
  "worksheets.task-types.mathematics.pyramid": "Number pyramid",
  "worksheets.task-types.mathematics.sorting": "Sorting",
  "worksheets.task-types.mathematics.standardAlgorithm": "Standard algorithm",
  "worksheets.task-types.mathematics.sudoku": "Sudoku",
  "worksheets.themes.17mai": "17th of may",
  "worksheets.themes.christmas": "Christmas",
  "worksheets.themes.halloween": "Halloween",
  "worksheets.themes.mermaids": "Mermaids",
  "worksheets.themes.numberchars": "Numbers and letters",
  "worksheets.themes.space": "Space",
  "worksheets.themes.tools": "Pencil and paper",
  "worksheets.themes.unicorn": "Unicorn",
  "worksheets.title-placeholder": "Worksheet nr. {total} - {date}",
  "worksheets.wordlist-modal.edit-words": "Edit words",
  "worksheets.worksheet-generator": "Worksheet generator",

  // Onboarding Tour
  "onboarding.tour.welcome.title": "Welcome to the New Generator!",
  "onboarding.tour.welcome.description":
    "This new worksheet generator gives you instant preview of your worksheets as you create them. Let's take a quick tour!",
  "onboarding.tour.preview.title": "Instant Preview",
  "onboarding.tour.preview.description":
    "See your worksheet update in real-time as you make changes. No more waiting for the PDF to generate!",
  "onboarding.tour.tabs.title": "Switch Subjects",
  "onboarding.tour.tabs.description":
    "Choose between Mathematics, Norwegian, and English worksheets using these tabs.",
  "onboarding.tour.settings.title": "Configure Your Worksheet",
  "onboarding.tour.settings.description":
    "Set the name, grade level, operations, layout, task types, and theme for your worksheet here.",
  "onboarding.tour.pages.title": "Add Pages",
  "onboarding.tour.pages.description":
    "Use the + and - buttons to add or remove pages from your worksheet. Try clicking + to add a page!",
  "onboarding.tour.page-config.title": "Page-by-Page Editing",
  "onboarding.tour.page-config.description":
    "Each page can be customized individually. Click to expand and see options for each task.",
  "onboarding.tour.configure.title": "Configure Tasks",
  "onboarding.tour.configure.description":
    "Click this button to customize the details of a specific task, such as difficulty level or number range.",
  "onboarding.tour.module-regenerate.title": "Regenerate Task",
  "onboarding.tour.module-regenerate.description":
    "After changing a task's configuration, click this button to regenerate just that task. No other tasks in your worksheet will be affected.",
  "onboarding.tour.global-regenerate.title": "Regenerate All",
  "onboarding.tour.global-regenerate.description":
    "Click here to regenerate all tasks on the entire worksheet with the selected settings.",
  "onboarding.tour.download.title": "Download PDF",
  "onboarding.tour.download.description":
    "Download your worksheet as a PDF file to print or share.",
  "onboarding.tour.save.title": "Save to Library",
  "onboarding.tour.save.description":
    "Save your worksheet to your library for easy access later. It will also be downloaded automatically.",
  "onboarding.tour.done.title": "You're All Set!",
  "onboarding.tour.done.description":
    "You now know the basics of the new generator. Start creating your worksheet! You can retake this tour anytime by clicking the help button.",
  "onboarding.tour.buttons.next": "Next",
  "onboarding.tour.buttons.prev": "Previous",
  "onboarding.tour.buttons.done": "Get Started",
  "onboarding.tour.buttons.skip": "Skip Tour",
  "onboarding.tour.help-button.tooltip": "Take the tour",
}
export default en
